// extracted by mini-css-extract-plugin
export default {"message":"PaymentMessage--message--f8be91","attention":"PaymentMessage--attention--ca6f77","button":"PaymentMessage--button--69b2f2"};